export enum AmostrasComerciaisEventsEnum {
  Criadas = 'amostras-comerciais-cadastro',
}
